export const DEPLOYABLE_ARTIFACT_TYPE = {
  XmlPolicy: 'XmlPolicy',
  CompiledPolicy: 'CompiledPolicy',
  SignedCompiledPolicy: 'SignedCompiledPolicy',
  UnsignedCatalog: 'UnsignedCatalog',
  SignedCatalog: 'SignedCatalog',
};

const DEPLOYABLE_ARTIFACT_TYPE_MAPPING = [
  {
    value: DEPLOYABLE_ARTIFACT_TYPE.XmlPolicy,
    label: 'XML Policy',
    color: '#9CA3AF',
    isCatalog: false,
  },
  {
    value: DEPLOYABLE_ARTIFACT_TYPE.CompiledPolicy,
    label: 'Compiled Policy',
    color: '#87C8E0',
    isCatalog: false,
  },
  {
    value: DEPLOYABLE_ARTIFACT_TYPE.SignedCompiledPolicy,
    label: 'Signed Compiled Policy',
    color: '#7DFF92',
    isCatalog: false,
  },
  {
    value: DEPLOYABLE_ARTIFACT_TYPE.UnsignedCatalog,
    label: 'Unsigned Catalog',
    color: '#E0A23C',
    isCatalog: true,
  },
  {
    value: DEPLOYABLE_ARTIFACT_TYPE.SignedCatalog,
    label: 'Signed Catalog',
    color: '#7DFF92',
    isCatalog: true,
  },
];

export const getDeployableArtifactTypeLabel = value =>
  DEPLOYABLE_ARTIFACT_TYPE_MAPPING.find(item => item.value === value)?.label ??
  (value != null && value !== '' ? String(value).replace(/([a-z])([A-Z])/g, '$1 $2') : '');

export const getDeployableArtifactTypeColor = value =>
  DEPLOYABLE_ARTIFACT_TYPE_MAPPING.find(item => item.value === value)?.color ?? '#9CA3AF';

export const isDeployableArtifactCatalog = value =>
  DEPLOYABLE_ARTIFACT_TYPE_MAPPING.find(item => item.value === value)?.isCatalog ?? false;

export const getDeployableArtifactTypeOptions = () =>
  DEPLOYABLE_ARTIFACT_TYPE_MAPPING.map(({ value, label }) => ({ value, label }));
